<template>
  <div class="home">
      <img class="logo" :src="`${publiPath}/schoolLogo.png`" />

    <div class="centerContent">
      <div class="titleContent">
        <div class="log">
          <login></login>
        </div>
       
      </div>
      <div class="title">
        <span>统一身份认证系统</span>
      </div>
    </div>
       <p class="version">V2.1.5 build-2103031</p>

  </div>
</template>
<script>
import login from "./login";
export default {
  data() {
    return {
      activeName: "one",
      publiPath:process.env.BASE_URL
    };
  },
  methods: {},
  components: {
    login,
  },
};
</script>
<style scoped>
.home {
  background: #fbfcff url("../assets/backg.png") no-repeat fixed center;
  background-size: 100% auto;
  height: 100vh;
}
.centerContent {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  height: 700px;
  width: 70em;
  background: white;
  margin: auto;
  position: relative;
  top: 100px;
  background: #fbfcff url("../assets/loginBackg.png") no-repeat content-box
    center;
  background-size: 100% auto;
}
.title {
  background: #bf3636;
  height: 60px;
  width: 320px;
  position: relative;
  top: 60px;
  left: -20px;
  padding: auto;
}
.title::after {
  content: "";
  width: 0;
  height: 0;
  border-bottom: 60px solid #bf3636;
  /* border-bottom: 80px solid white; */
  border-right: 50px solid transparent;
  position: absolute;
  top: 0px;
  right: -50px;
}
.title span {
  color: white;
  font-weight: 800;
  font-size: 30px;
  line-height: 60px;
  padding-left: 50px;
}
.titleContent {
  background: rgba(255, 255, 255, 0.3);
  position: relative;
  float: right;
  width: 50%;
  height: 100%;
}
.log {
  width: 500px;
  margin: 100px auto;
  font-family: "Microsoft YaHei";
}
.version{
    position: fixed;
    bottom: 10px;
    width: 100%;
    text-align: center;
    color: #e6e6e6;
    font-size: 14px;
    z-index: 0;
}
</style>
<style>
.logo{
  width: 200px;
  left: 30px;
  position: absolute;
  margin-top: 10px;
}
</style>